import { render } from "./RecommendationMatrixView.vue?vue&type=template&id=6b2da3f6&scoped=true"
import script from "./RecommendationMatrixView.vue?vue&type=script&lang=js"
export * from "./RecommendationMatrixView.vue?vue&type=script&lang=js"

import "./RecommendationMatrixView.vue?vue&type=style&index=0&id=6b2da3f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2da3f6"]])

export default __exports__